<template>
    <div>
        <component style="display: none" :is="show_document"></component>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol>
                                <strong>{{$t('sidebars.listDocuments')}}</strong>
                            </CCol>
                            <CCol class="text-left">
                                <CButton @click="AddAllRefer()" size="sm" color="primary">
                                    ارجاع انتخاب شده ها
                                </CButton>
                            </CCol>

                        </CRow><CRow>
                            <CCol col="3">
                                <date-picker
                                        format="YYYY/MM/DD"
                                        :timezone="true"
                                        display-format="jYYYY/jMM/jDD"
                                        label="تاریخ شروع" v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        type="datetime"
                                        display-format="jYYYY/jMM/jDD"
                                        locale="fa"
                                        format="YYYY/MM/DD"
                                        :timezone="true"
                                        :label="$t('endDate')"
                                        v-model="end_date"></date-picker>

                            </CCol>

                        </CRow>

                    </CCardHeader>
                    <CCardBody>

                        <CCard v-if="submit_refer!=0">
                            <CCardHeader>
                                <strong>ارجاع به کاربر</strong>
                            </CCardHeader>
                            <CCardBody>
                                <CForm>


                                    <CCol sm="6" md="4">
                                        <CRow>
                                            <CCol sm="12">
                                                <treeselect
                                                        v-model="refer_person"
                                                        :cacheOptions="false"
                                                        :async="true"
                                                        :load-options="load_persons"
                                                        :placeholder="$t('components.searchUser')"
                                                        :normalizer="normalizer_persons"
                                                />

                                            </CCol>
                                        </CRow>

                                    </CCol>

                                </CForm>
                            </CCardBody>
                            <CCardFooter>
                                <CButton @click="insert_refer()" type="submit" size="sm" color="primary">
                                    <CIcon name="cil-check-circle"/>
                                    ارجاع به کاربر
                                </CButton>

                                <CButton @click="submit_refer = 0,id_checkbox_items=[]" type="reset" size="sm"
                                         color="danger">
                                    <CIcon name="cil-ban"/>
                                    {{$t("buttons.cancel")}}
                                </CButton>
                            </CCardFooter>
                        </CCard>


                        <CTabs>
                            <CTab :title="$t('buy')">
                                <CDataTable
                                        :items="items_buy"
                                        :fields="fields"

                                        :items-per-page="20"
                                        hover
                                        sorter
                                        pagination
                                >
                                    <template #ردیف="{item}">

                                        <td>
                                            <p >{{item.row_id+1}}</p>

                                        </td>

                                    </template>
                                    <template #createdAt="{item}">

                                        <td>
                                            <p >{{item.createdAt}}</p>

                                        </td>

                                    </template>

                                    <template #انبار="{item}">
                                        <td>
                                            <p >{{item.placeName}}</p>

                                        </td>

                                    </template>
                                    <template #مبلغ="{item}">

                                        <td>
                                            <p >{{item.totalPrice}}</p>

                                        </td>


                                    </template>
                                    <template #طرف_حساب="{item}">

                                        <td>
                                            <p >{{item.partyName}}({{item.tablo}})</p>

                                        </td>

                                    </template>
                                    <template #toziKonande="{item}">

                                        <td>
                                            <p v-if="item.toziKonande!=null" >{{item.toziKonande}}</p>

                                        </td>

                                    </template>
                                    <template #کاربر="{item}">

                                        <td>
                                            <p >{{item.createdBy}}</p>

                                        </td>

                                    </template>


                                    <template #عملیات="{item,index}">
                                        <td >
                                            <CButton v-if="item.statusId !=0"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     size="sm"
                                                     @click="goReturnDocument(item,index)"
                                            >سند برگشت
                                            </CButton>
                                            <CButton
                                                    color="primary"
                                                    variant="outline"
                                                    square
                                                    size="sm"
                                                    @click="goShowDocument(item,index)"
                                            >{{$t('buttons.edit')}}
                                            </CButton>
                                            <CButton v-if="item.statusId !=0 && item.toziKonande==null"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     size="sm"
                                                     @click="AddRefer(item,index)"
                                            >ارجاع
                                            </CButton>

                                            <CButton v-if="item.statusId ==0"
                                                     color="primary"
                                                     square
                                                     size="sm"
                                                     @click="Finalize(item,index)"
                                            >نهایی کردن
                                            </CButton>
                                        </td>
                                    </template>
                                    <template #انتخاب="{item}">

                                    </template>

                                </CDataTable>

                            </CTab>
                            <CTab title="برگشت خرید">
                                <CDataTable
                                        :items="items_buy_return"
                                        :fields="fields"

                                        :items-per-page="20"
                                        hover
                                        sorter
                                        pagination
                                >
                                    <template #ردیف="{item}">

                                        <td>
                                            <p >{{item.row_id+1}}</p>

                                        </td>

                                    </template>
                                    <template #createdAt="{item}">

                                        <td>
                                            <p >{{item.createdAt}}</p>

                                        </td>

                                    </template>

                                    <template #انبار="{item}">
                                        <td>
                                            <p >{{item.placeName}}</p>

                                        </td>

                                    </template>
                                    <template #مبلغ="{item}">

                                        <td>
                                            <p >{{item.totalPrice}}</p>

                                        </td>


                                    </template>
                                    <template #طرف_حساب="{item}">

                                        <td>
                                            <p >{{item.partyName}}({{item.tablo}})</p>

                                        </td>

                                    </template>
                                    <template #toziKonande="{item}">

                                        <td>
                                            <p v-if="item.toziKonande!=null" >{{item.toziKonande}}</p>

                                        </td>

                                    </template>
                                    <template #کاربر="{item}">

                                        <td>
                                            <p >{{item.createdBy}}</p>

                                        </td>

                                    </template>


                                    <template #عملیات="{item,index}">
                                        <td>
                                            <CButton v-if="item.statusId !=0"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     size="sm"
                                                     @click="goReturnDocument(item,index)"
                                            >سند برگشت
                                            </CButton>
                                            <CButton
                                                    color="primary"
                                                    variant="outline"
                                                    square
                                                    size="sm"
                                                    @click="goShowDocument(item,index)"
                                            >{{$t('buttons.show')}}
                                            </CButton>
                                            <CButton v-if="item.statusId !=0 && item.toziKonande==null"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     size="sm"
                                                     @click="AddRefer(item,index)"
                                            >ارجاع
                                            </CButton>

                                            <CButton v-if="item.statusId ==0"
                                                     color="primary"
                                                     square
                                                     size="sm"
                                                     @click="Finalize(item,index)"
                                            >نهایی کردن
                                            </CButton>
                                        </td>
                                    </template>
                                    <template #انتخاب="{item}">

                                    </template>

                                </CDataTable>

                            </CTab>
                            <CTab :title="$t('sell')" active>
                                <CDataTable
                                        :items="items_sell"
                                        :fields="fields"

                                        :items-per-page="20"
                                        hover
                                        sorter
                                        :sorter-value="{column:'recId',asc:false}"
                                        pagination
                                >
                                    <template #ردیف="{item}">

                                        <td>
                                            <p >{{item.row_id+1}}</p>

                                        </td>

                                    </template>
                                    <template #createdAt="{item}">

                                        <td>
                                            <p >{{item.createdAt}}</p>

                                        </td>

                                    </template>

                                    <template #انبار="{item}">
                                        <td>
                                            <p >{{item.placeName}}</p>

                                        </td>

                                    </template>
                                    <template #مبلغ="{item}">

                                        <td>
                                            <p >{{item.totalPrice}}</p>

                                        </td>


                                    </template>
                                    <template #طرف_حساب="{item}">

                                        <td>
                                            <p >{{item.partyName}}({{item.tablo}})</p>

                                        </td>

                                    </template>
                                    <template #toziKonande="{item}">

                                        <td>
                                            <p v-if="item.toziKonande!=null" >{{item.toziKonande}}</p>

                                        </td>

                                    </template>
                                    <template #کاربر="{item}">

                                        <td>
                                            <p >{{item.createdBy}}</p>

                                        </td>

                                    </template>


                                    <template #عملیات="{item,index}">
                                        <td class="py-2">
                                            <CButton v-if="item.statusId !=0"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     size="sm"
                                                     @click="goReturnDocument(item,index)"
                                            >سند برگشت
                                            </CButton>
                                            <CButton
                                                    class="m-1"
                                                    color="primary"
                                                    variant="outline"
                                                    square
                                                    :title="$t('buttons.show')"
                                                    size="sm"
                                                    @click="goShowDocument(item,index)"
                                            ><CIcon name="cil-speedometer"/>
                                            </CButton>
                                            <CButton
                                                    class="m-1"
                                                    color="success"
                                                    square
                                                    size="sm"
                                                    :title="$t('buttons.print')"
                                                    @click="goPrintDocument(item,index)"
                                            ><CIcon name="cil-print"/>
                                            </CButton>
                                            <CButton v-if="item.statusId !=0 && item.toziKonande==null"
                                                     class="m-1"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     title="ارجاع"
                                                     size="sm"
                                                     @click="AddRefer(item,index)"
                                            ><CIcon name="cilShare" />
                                            </CButton>

                                            <CButton v-if="item.statusId ==0"
                                                     class="m-1"
                                                     color="primary"
                                                     square
                                                     size="sm"
                                                     title="نهایی کردن"
                                                     @click="Finalize(item,index)"
                                            ><CIcon name="cil-https" />
                                            </CButton>
                                         </td>
                                    </template>

                                    <template #انتخاب="{item}">
                                        <td class="py-2">

                                            <CCol v-if="item.statusId !=0 && item.toziKonande==null">

                                                <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                                                       :value="item.recId"/>

                                            </CCol>

                                        </td>
                                    </template>
                                </CDataTable>

                            </CTab>
                            <CTab title="برگشت فروش">
                                <CDataTable
                                        :items="items_sell_return"
                                        :fields="fields"

                                        :items-per-page="20"
                                        hover
                                        sorter
                                        pagination
                                >
                                    <template #ردیف="{item}">

                                        <td>
                                            <p >{{item.row_id+1}}</p>

                                        </td>

                                    </template>
                                    <template #createdAt="{item}">

                                        <td>
                                            <p >{{item.createdAt}}</p>

                                        </td>

                                    </template>

                                    <template #انبار="{item}">
                                        <td>
                                            <p >{{item.placeName}}</p>

                                        </td>

                                    </template>
                                    <template #مبلغ="{item}">

                                        <td>
                                            <p >{{item.totalPrice}}</p>

                                        </td>


                                    </template>
                                    <template #طرف_حساب="{item}">

                                        <td>
                                            <p >{{item.partyName}}({{item.tablo}})</p>

                                        </td>

                                    </template>
                                    <template #toziKonande="{item}">

                                        <td>
                                            <p v-if="item.toziKonande!=null" >{{item.toziKonande}}</p>

                                        </td>

                                    </template>
                                    <template #کاربر="{item}">

                                        <td>
                                            <p >{{item.createdBy}}</p>

                                        </td>

                                    </template>


                                    <template #عملیات="{item,index}">
                                        <td class="py-2">
                                            <CButton v-if="item.statusId !=0"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     size="sm"
                                                     @click="goReturnDocument(item,index)"
                                            >سند برگشت
                                            </CButton>
                                            <CButton
                                                    color="primary"
                                                    variant="outline"
                                                    square
                                                    size="sm"
                                                    @click="goShowDocument(item,index)"
                                            >{{$t('buttons.show')}}
                                            </CButton>
                                            <CButton v-if="item.statusId !=0 && item.toziKonande==null"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     size="sm"
                                                     @click="AddRefer(item,index)"
                                            >ارجاع
                                            </CButton>

                                            <CButton v-if="item.statusId ==0"
                                                     color="primary"
                                                     square
                                                     size="sm"
                                                     @click="Finalize(item,index)"
                                            >نهایی کردن
                                            </CButton>
                                         </td>
                                    </template>
                                    <template #انتخاب="{item}">

                                    </template>

                                </CDataTable>

                            </CTab>
                            <CTab title="اول دوره">
                                <CDataTable
                                        :items="items_first"
                                        :fields="fields"

                                        :items-per-page="20"
                                        hover
                                        sorter
                                        pagination
                                >
                                    <template #ردیف="{item}">

                                        <td>
                                            <p >{{item.row_id+1}}</p>

                                        </td>

                                    </template>
                                    <template #createdAt="{item}">

                                        <td>
                                            <p >{{item.createdAt}}</p>

                                        </td>

                                    </template>

                                    <template #انبار="{item}">
                                        <td>
                                            <p >{{item.placeName}}</p>

                                        </td>

                                    </template>
                                    <template #مبلغ="{item}">

                                        <td>
                                            <p >{{item.totalPrice}}</p>

                                        </td>


                                    </template>
                                    <template #طرف_حساب="{item}">

                                        <td>
                                            <p >{{item.partyName}}({{item.tablo}})</p>

                                        </td>

                                    </template>
                                    <template #toziKonande="{item}">

                                        <td>
                                            <p v-if="item.toziKonande!=null" >{{item.toziKonande}}</p>

                                        </td>

                                    </template>
                                    <template #کاربر="{item}">

                                        <td>
                                            <p >{{item.createdBy}}</p>

                                        </td>

                                    </template>


                                    <template #عملیات="{item,index}">
                                        <td class="py-2">
                                            <CButton v-if="item.statusId !=0"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     size="sm"
                                                     @click="goReturnDocument(item,index)"
                                            >سند برگشت
                                            </CButton>
                                            <CButton
                                                    color="primary"
                                                    variant="outline"
                                                    square
                                                    size="sm"
                                                    @click="goShowDocument(item,index)"
                                            >{{$t('buttons.show')}}
                                            </CButton>
                                            <CButton v-if="item.statusId !=0 && item.toziKonande==null"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     size="sm"
                                                     @click="AddRefer(item,index)"
                                            >ارجاع
                                            </CButton>

                                            <CButton v-if="item.statusId ==0"
                                                     color="primary"
                                                     square
                                                     size="sm"
                                                     @click="Finalize(item,index)"
                                            >نهایی کردن
                                            </CButton>
                                        </td>
                                    </template>
                                    <template #انتخاب="{item}">

                                    </template>


                                </CDataTable>

                            </CTab>
                            <CTab title="برگشت اول دوره">
                                <CDataTable
                                        :items="items_first_return"
                                        :fields="fields"

                                        :items-per-page="20"
                                        hover
                                        sorter
                                        pagination
                                >
                                    <template #ردیف="{item}">

                                        <td>
                                            <p >{{item.row_id+1}}</p>

                                        </td>

                                    </template>
                                    <template #createdAt="{item}">

                                        <td>
                                            <p >{{item.createdAt}}</p>

                                        </td>

                                    </template>

                                    <template #انبار="{item}">
                                        <td>
                                            <p >{{item.placeName}}</p>

                                        </td>

                                    </template>
                                    <template #مبلغ="{item}">

                                        <td>
                                            <p >{{item.totalPrice}}</p>

                                        </td>


                                    </template>
                                    <template #طرف_حساب="{item}">

                                        <td>
                                            <p >{{item.partyName}}({{item.tablo}})</p>

                                        </td>

                                    </template>
                                    <template #toziKonande="{item}">

                                        <td>
                                            <p v-if="item.toziKonande!=null" >{{item.toziKonande}}</p>

                                        </td>

                                    </template>
                                    <template #کاربر="{item}">

                                        <td>
                                            <p >{{item.createdBy}}</p>

                                        </td>

                                    </template>


                                    <template #عملیات="{item,index}">
                                        <td class="py-2">
                                            <CButton v-if="item.statusId !=0"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     size="sm"
                                                     @click="goReturnDocument(item,index)"
                                            >سند برگشت
                                            </CButton>
                                            <CButton
                                                    color="primary"
                                                    variant="outline"
                                                    square
                                                    size="sm"
                                                    @click="goShowDocument(item,index)"
                                            >{{$t('buttons.show')}}
                                            </CButton>
                                            <CButton v-if="item.statusId !=0 && item.toziKonande==null"
                                                     color="primary"
                                                     variant="outline"
                                                     square
                                                     size="sm"
                                                     @click="AddRefer(item,index)"
                                            >ارجاع
                                            </CButton>

                                            <CButton v-if="item.statusId ==0"
                                                     color="primary"
                                                     square
                                                     size="sm"
                                                     @click="Finalize(item,index)"
                                            >نهایی کردن
                                            </CButton>
                                        </td>
                                    </template>
                                    <template #انتخاب="{item}">

                                    </template>

                                </CDataTable>

                            </CTab>
                        </CTabs>
                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items_data = [];

    const fields = [
        {key: 'ردیف', label: this.$t('tables.row'), _style: 'width:2%'},
        {key: 'createdAt', label: 'تاریخ', _style: 'width:20%'},
        {key: 'recId', label: 'شماره', _style: 'width:2%'},
        {key: 'انبار', _style: 'width:10%'},
        {key: 'مبلغ', _style: 'width:10%'},
        {key: 'طرف_حساب', _style: 'width:20%'},
        {key: 'کاربر', _style: 'width:15%'},
        {key: 'toziKonande', label: this.$t('tables.driver'), _style: 'width:15%'},

        {key: 'عملیات', _style: 'width:20%;'},
        {key: 'انتخاب'},

    ];


    export default {
        name: 'Login',
        components: {
            Treeselect,
            'test-dynamic': () => import('../documents/PrintDocument'),

        },
        data() {
            return {
                show_document: 'test-dynamic',
                printed_doc_id:0,
                name: '',
                file: '',
                color: '#ffffff',
                start_date: '',
                end_date: '',
                previewImage: '',
                submit_refer: 0,
                refer_person: null,
                selected_template: 0,
                description: null,
                id_checkbox_items: [],
                item_sell_array:[],
                items_buy: items_data.map((item, row_id) => {
                    return {...item, row_id}


                }), items_buy_return: items_data.map((item, row_id) => {
                    return {...item, row_id}


                }),

                items_sell: items_data.map((item, row_id) => {

                    return {...item, row_id}

                }), items_sell_return: items_data.map((item, row_id) => {

                    return {...item, row_id}

                }),
                // fields,

                items_first: items_data.map((item, row_id) => {

                    return {...item, row_id}

                }),
                items_first_return: items_data.map((item, row_id) => {

                    return {...item, row_id}

                }),
                // fields,

                details: [],
                templates_items: [
                    {template_id: 'One', name: 'A'},
                    {template_id: 'Two', name: 'B'},
                    {template_id: 'Three', name: 'C'}
                ],
                collapseDuration: 0,
                status_form: 0,
                load_persons({action, searchQuery, callback}) {
                    var self = this;

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
                    }
                },

            }
        }, mounted() {

            this.start_date =  this.get_today();
            this.end_date =  this.get_today();
            this.$root.root_validate_errors = [];


            this.get_lists_buy();
            this.get_lists_buy_return();
            this.get_lists_sell(1);
            this.get_lists_sell_return();
            this.get_lists_first();
            this.get_lists_first_return();
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.date': function () {
                this.get_lists_buy();
                this.get_lists_buy_return();
                this.get_lists_sell(1);
                this.get_lists_sell_return();
                this.get_lists_first();
                this.get_lists_first_return();
            },
            '$route.params.person_id': function () {
                this.get_lists_buy();
                this.get_lists_buy_return();
                this.get_lists_sell(1);
                this.get_lists_sell_return();
                this.get_lists_first();
                this.get_lists_first_return();
            }
        },
        methods: {
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = this.items[item.row_id].unitName;
                this.color = this.items[item.row_id].color;
                this.description = this.items[item.row_id].description;
                this.previewImage = this.items[item.row_id].image;
                this.status_form = this.items[item.row_id].id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            }, emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_lists_buy() {
                var self = this;


                const formData = new FormData();
                var url = "GetDocsById";

                if (self.$route.params.date != null || self.$route.params.person_id != null) {

                    url = "GetDocsByParams";
                    formData.append("docType", 1);
                    if (self.$route.params.person_id != null) {
                        formData.append("PersonId", self.$route.params.person_id);

                    }
                }

                formData.append("id", 1);
                formData.append("SearchTxt", '');

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items_buy = content_data.data.map((item, row_id) => {
// if(item.isCustomer){
                            return {...item, row_id}

// }
                        });



                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_lists_buy_return() {
                var self = this;


                const formData = new FormData();

                var url = "GetDocsById";

                if (self.$route.params.date != null || self.$route.params.person_id != null) {

                    url = "GetDocsByParams";
                    formData.append("docType", 2);
                    if (self.$route.params.person_id != null) {
                        formData.append("PersonId", self.$route.params.person_id);

                    }
                }
                formData.append("id", 2);
                formData.append("SearchTxt", '');

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items_buy_return = content_data.data.map((item, row_id) => {
// if(item.isCustomer){
                            return {...item, row_id}

// }
                        }), fields;



                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_lists_sell(page) {
                var self = this;


                const formData = new FormData();

                var url = "GetDocsById";

                if (self.$route.params.date != null || self.$route.params.person_id != null) {

                    url = "GetDocsByParams";
                    formData.append("docType", 3);
                    if (self.$route.params.person_id != null) {
                        formData.append("PersonId", self.$route.params.person_id);

                    }
                }

                formData.append("id", 3);
                formData.append("Page", page);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        content_data.data.forEach((val) => {

                            self.item_sell_array.push(val);


                            });

                        if(content_data.data.length>0 && (self.$route.params.date == null && self.$route.params.person_id == null)){
                            self.get_lists_sell(page+1)
                        }else{
                            console.log(JSON.stringify(self.item_sell_array));
                            self.items_sell = self.item_sell_array.map((item, row_id) => {
                                return {...item, row_id}

                            });
                        }

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_lists_sell_return() {
                var self = this;


                const formData = new FormData();

                var url = "GetDocsById";

                if (self.$route.params.date != null || self.$route.params.person_id != null) {

                    url = "GetDocsByParams";
                    formData.append("docType", 4);
                    if (self.$route.params.person_id != null) {
                        formData.append("PersonId", self.$route.params.person_id);

                    }
                }
                formData.append("id", 4);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.items_sell_return = content_data.data.map((item, row_id) => {
                            return {...item, row_id}

                        });


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_lists_first() {
                var self = this;


                const formData = new FormData();

                var url = "GetDocsById";

                if (self.$route.params.date != null || self.$route.params.person_id != null) {

                    url = "GetDocsByParams";
                    formData.append("docType", 5);
                    if (self.$route.params.person_id != null) {
                        formData.append("PersonId", self.$route.params.person_id);

                    }
                }
                formData.append("id", 5);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.items_first = content_data.data.map((item, row_id) => {
                            return {...item, row_id}

                        });


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_lists_first_return() {
                var self = this;


                const formData = new FormData();

                var url = "GetDocsById";

                if (self.$route.params.date != null || self.$route.params.person_id != null) {

                    url = "GetDocsByParams";
                    formData.append("docType", 6);
                    if (self.$route.params.person_id != null) {
                        formData.append("PersonId", self.$route.params.person_id);

                    }
                }
                formData.append("id", 6);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.items_first_return = content_data.data.map((item, row_id) => {
                            return {...item, row_id}

                        });


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            Finalize(item, index) {
                var self = this;


                const formData = new FormData();

                var url = "AddFactorToFinal";

                formData.append("id", item.recId);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (content_data.statusCode == 0) {
                        item.statusId = 1;
                    } else {

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goReturnDocument(item, index) {
                this.$router.push({
                    path: '/dashboard/documents/return/' + item.recId + "/false",
                    params: {passed_data: "salam hamidddd"}
                });

                // this.$router.push({path: '/dashboard/users/edit-user/' + this.items[index].userId});
                // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            goShowDocument(item, index) {

                this.$router.push({path: '/dashboard/documents/show/' + item.recId});
                // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            goPrintDocument(item, index) {
                bus.$emit("print_confirm", item.recId);

                // this.pri/nted_doc_id = item.recId;                 // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            AddRefer(item, index) {
                this.submit_refer = item.recId;
                // this.$router.push({path: '/dashboard/documents/show/' + item.recId});
                // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

            AddAllRefer() {
                this.submit_refer = -1;
                if (this.id_checkbox_items.length == 0) {
                    console.log("validate form is false" + this.validate_errors);
                    this.submit_refer = 0;

                }
            },
          delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = this.items[item.row_id].id;

            }, delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeletePerson";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();

                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            insert_refer() {
                let self = this;

                if (this.submit_refer != -1) {


                    this.id_checkbox_items = [];
                } else {
                    if (this.id_checkbox_items.length == 0) {
                        console.log("validate form is false" + this.validate_errors);
                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        return true;
                    }

                }
                if (this.refer_person == null) {
                    console.log("validate form is false" + this.validate_errors);

                    return true;
                }
                let url;
                // if (this.status_form == 0) {
                url = "AddFactorRefer";
                // }
                if (this.submit_refer != -1) {
                    const formData = new FormData();

                    formData.append('PersonId', this.refer_person);

                    formData.append('MasterFactorId', this.submit_refer);
                    axios.post(url, formData, {}).then((res) => {



                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        self.refer_person = null;
                        // self.color = '';
                        // self.description = '';
                        // self.previewImage = '';
                        // self.get_lists();

                        self.$root.modal_component.show_api_response_modals(res);
                        self.get_lists_buy();
                        self.get_lists_buy_return();
                        self.get_lists_sell(1);
                        self.get_lists_sell_return();
                        self.get_lists_first();
                        self.get_lists_first_return();
                    })
                        .catch(function (error) {
                            console.log(error);
                        });
                } else {
                    self.id_checkbox_items.forEach((val) => {

                        const formData = new FormData();

                        formData.append('PersonId', this.refer_person);

                        formData.append('MasterFactorId', val);
                        axios.post(url, formData, {}).then((res) => {
                            //



                        })
                            .catch(function (error) {

                                console.log(error);
                            });
                    });
                    self.id_checkbox_items = [];
                    self.submit_refer = 0;
                    self.id_checkbox_items = [];

                    self.refer_person = null;
                    // self.color = '';
                    // self.description = '';
                    // self.previewImage = '';
                    // self.get_lists();

                    //this.$root.modal_component.show_api_response_modals(res);

                    this.get_lists_buy();
                    this.get_lists_buy_return();
                    this.get_lists_sell(1);
                    this.get_lists_sell_return();
                    this.get_lists_first();
                    this.get_lists_first_return();
                }


            },

        },

    }

</script>
